module.exports = __webpack_public_path__ + "img/event_icon02.ff29a54d.svg";